<section id="section02">

  <div class="container-fluid container-xl">
    
    <div class="row d-flex justify-content-center align-items-stretch">

        <div class="col-lg-12 p-4">

            <div class="row d-flex justify-content-around align-items-start">
              <div *ngFor="let detalhe of data.DETALHES_01" class="col-lg-3 px-3 py-3 text-center">
                <div class="px-5">
                  <img src="{{ detalhe.IMAGEM.URL }}" alt="{{ detalhe.IMAGEM.DESCRICAO }}" class="img-fluid">
                </div> 
                <p class="titulo mt-2 mb-2" [innerHTML]="detalhe.TITULO"></p>
                <p class="subtitulo mb-0">{{ detalhe.SUBTITULO }}</p>
              </div>
            </div>

            <div class="row d-flex justify-content-around align-items-start">
              <div *ngFor="let detalhe of data.DETALHES_02;" class="col-lg-3 px-3 py-3 text-center">
                <div class="px-5">
                    <img src="{{ detalhe.IMAGEM.URL }}" alt="{{ detalhe.IMAGEM.DESCRICAO }}" class="img-fluid">
                </div>
                <p class="titulo mt-2 mb-2">{{ detalhe.TITULO }}</p>
                <p class="subtitulo mb-0">{{ detalhe.SUBTITULO }}</p>
              </div>

              <div class="col-lg-3 pb-3 pt-lg-3">
                <div class="row">
                  <div *ngFor="let detalhe of data.DETALHES_03;" class="col-lg-12 px-3 py-3 py-lg-2 d-lg-flex justify-content-center align-items-center">
                    <div class="d-flex justify-content-center justify-lg-content-start col-lg-6">
                      <img src="{{ detalhe.IMAGEM.URL }}" alt="{{ detalhe.IMAGEM.DESCRICAO }}" class="img-fluid">
                    </div>
                    <div class="text-center text-lg-left">
                      <p class="titulo mt-2 mb-2">{{ detalhe.TITULO }}</p>
                      <p class="subtitulo mb-0">{{ detalhe.SUBTITULO }}</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

        </div>    

    </div>    

  </div>

</section>